
import { mapperPaymentsPaymentMethod } from '../payment-methods/mapper-payments-payment-method'

/**
 * Page payment method detail mapper
 * normalizes data to be used in pages
 *
 */
export const mapperRelatedPaymentMethodsDetail = (items: any[], paymentMethodsGlobalContent: any[], getUrl: Function) => {
    if (!items) {
        return { related: [] }
    }

    const computedRelatedPaymentMethods = items?.map(item => ({
        pageId: item.sys?.id || item.pageId,
        ...paymentMethodsGlobalContent?.find(method => method.sys.id === item.paymentMethod?.sys?.id || method.sys.id === item.id)
    })) || []

    return computedRelatedPaymentMethods.map(item => mapperPaymentsPaymentMethod(item, getUrl)) || []
}
